import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [
  	'facilitatorCheckbox',
  	'coachCheckbox',
  	'learnerCheckbox',
  	'coachDropdown',
  	'learnerDropdown',
    'mentoredLearner'
 	];

  static values = {
    mentoringUrl: String,
    confirmAllow: String,
    confirmCancel: String,
    confirmLearnerTitle: String,
    confirmCoachTitle: String,
    confirmFacilitatorTitle: String,
    confirmLearnerMessage: String,
    confirmCoachMessage: String,
    confirmFacilitatorMessage: String,
    confirmCheckboxMessage: String
  }

  connect() {
    this.learner_ids = new Set();

    if (this.hasMentoredLearnerTarget) {
      this.mentoredLearnerTargets.forEach((learner) => {
        this.learner_ids.add(learner.dataset.id);
      });
    }

    this.toggleCheckboxRequired();
  }

  toggleLearnerCheckbox(event) {
    const target = this.learnerCheckboxTarget;

    this._handleCheckboxToggle({
      event,
      target,
      modalDataset: this._learnerConfirmationModalDataset(),
      afterToggle: () => {
        this.toggleCheckboxRequired();
        this.toggleCoachDropdown();
      }
    });
  }

  toggleCoachCheckbox(event) {
    const target = this.coachCheckboxTarget;

    this._handleCheckboxToggle({
      event,
      target,
      modalDataset: this._coachConfirmationModalDataset(),
      afterToggle: () => {
        this.toggleCheckboxRequired();
        this.toggleLearnerDropdown();
      }
    });
  }

  toggleFacilitatorCheckbox(event) {
    const target = this.facilitatorCheckboxTarget;

    this._handleCheckboxToggle({
      event,
      target,
      modalDataset: this._facilitatorConfirmationModalDataset(),
      afterToggle: () => {
        this.toggleCheckboxRequired();
      }
    });
  }

  _handleCheckboxToggle({ event, target, modalDataset, afterToggle }) {
    const requiresConfirmation = target.dataset.interactions === 'true';

    if (target.checked) {
      afterToggle();
      return;
    }

    if (requiresConfirmation) {
      const confirmed = Rails.confirm(null, event.target, modalDataset);
      if (!confirmed) {
        target.checked = true;
        return;
      }
    }

    afterToggle();
  }


  addLearner(event) {
    event.preventDefault();

    let target = event.target;

    if (target.dataset.value === undefined && target.classList.contains('js-menu-option-text')) {
      target = target.parentNode;
    }

    this.learner_ids.add(target.dataset.value);

    this._loadLearnerDropdown();
  }

  removeLearner(event) {
    event.preventDefault();

    let target = event.target;

    if (target.dataset.id === undefined) {
      target = event.target.parentElement
    }

    this.learner_ids.delete(target.dataset.id);

    this._loadLearnerDropdown();
  }

  // Dropdown with learners options to the coach role
 	toggleLearnerDropdown() {
 		if (this.coachCheckboxTarget.checked) {
      this._loadLearnerDropdown();
 		} else {
      this.learnerDropdownTarget.classList.add('hidden');
      this.learnerDropdownTarget.innerHTML = '';
 		}
 	}

  // Dropdown with coaches options to the learner role
 	toggleCoachDropdown() {
 		if (this.learnerCheckboxTarget.checked) {
      this._loadCoachDropdown();
 		} else {
 			this.coachDropdownTarget.classList.add('hidden');
      this.coachDropdownTarget.innerHTML = '';
 		}
 	}

  toggleCheckboxRequired() {
    const checkboxes = [
      this.learnerCheckboxTarget,
      this.coachCheckboxTarget,
      this.facilitatorCheckboxTarget
    ];

    const isAnyChecked = checkboxes.some(checkbox => checkbox.checked);

    checkboxes.forEach(checkbox => {
      checkbox.required = !isAnyChecked;
    });
  }

  _loadLearnerDropdown() {
    const base = window.location.origin;
    const url = new URL(this.mentoringUrlValue, base);

    url.searchParams.append('role', 'coach');

    const ids = Array.from(this.learner_ids);
    if (ids) { ids.forEach(id => url.searchParams.append('mentored_learners_ids[]', id)); }

    this._load(url.toString(), this.learnerDropdownTarget);
 	}

  _loadCoachDropdown() {
    const base = window.location.origin;
    const url = new URL(this.mentoringUrlValue, base);

    url.searchParams.append('role', 'learner');

    this._load(url.toString(), this.coachDropdownTarget);
  }

  _load(url, target) {
    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'script',
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      },
      success: (data) => {
        if (target) { target.classList.remove('hidden') }
      },
    });
  }

  _learnerConfirmationModalDataset() {
    return {
      confirmError: true,
      confirmCancel: this.confirmCancelValue,
      confirmAllow: this.confirmAllowValue,
      confirmMessage: this.confirmLearnerMessageValue,
      confirmTitle: this.confirmLearnerTitleValue,
      confirmCheck: 'true',
      confirmCheckMessage: this.confirmCheckboxMessageValue

    };
  }

  _coachConfirmationModalDataset() {
    return {
      confirmError: true,
      confirmCancel: this.confirmCancelValue,
      confirmAllow: this.confirmAllowValue,
      confirmMessage: this.confirmCoachMessageValue,
      confirmTitle: this.confirmCoachTitleValue,
      confirmCheck: 'true',
      confirmCheckMessage: this.confirmCheckboxMessageValue

    };
  }

  _facilitatorConfirmationModalDataset() {
    return {
      confirmError: true,
      confirmCancel: this.confirmCancelValue,
      confirmAllow: this.confirmAllowValue,
      confirmMessage: this.confirmFacilitatorMessageValue,
      confirmTitle: this.confirmFacilitatorTitleValue,
      confirmCheck: 'true',
      confirmCheckMessage: this.confirmCheckboxMessageValue
    };
  }

}
